import { z } from "zod";

export const bulkQuoteBatchStatusValueSchema = z.enum([
	"accepted",
	"processing",
	"completed",
	"completed_with_errors",
	"failed",
]);

export const bulkQuoteBatchStatusSchema = z.object({
	bulkQuoteId: z.string().uuid(),
	templateType: z.string().nullable(),
	requestCount: z.number().int().nonnegative(),
	processedCount: z.number().int().nonnegative(),
	errorCount: z.number().int().nonnegative(),
	pendingCount: z.number().int().nonnegative(),
	status: bulkQuoteBatchStatusValueSchema,
	receivedAtUtc: z.string(),
	completedAtUtc: z.string().nullable(),
});

export type BulkQuoteBatchStatus = z.infer<typeof bulkQuoteBatchStatusSchema>;
export type BulkQuoteBatchStatusValue = z.infer<
	typeof bulkQuoteBatchStatusValueSchema
>;
